<template>
    <div class="p-2 mb-3">
        <!--ADD DIX TRANSLATION-->
        <div class="col-12 dflex checkbox-wrapper">
            <input
                :id="'chkshowastiles' + $vnode.key"
                type="checkbox"
                v-model="element.showastiles"
            />
            <label :for="'chkshowastiles' + $vnode.key">{{ $t("showAsTiles") }}</label>
        </div>
        <div class="col-12 dflex checkbox-wrapper">
            <input
                :id="'chkEmphasized' + $vnode.key"
                type="checkbox"
                v-model="element.emphasized"
            />
            <label :for="'chkEmphasized' + $vnode.key">{{ $t("emphasized") }}</label>
        </div>
        <div class="col-12 dflex checkbox-wrapper">
            <input
                :id="'chkisRequired' + $vnode.key"
                type="checkbox"
                v-model="element.isRequired"
            />
            <label :for="'chkisRequired' + $vnode.key">{{ $t("isRequired") }}</label>
        </div>
        <!--DIX-->
        <!--FOR EACH TRANSLATION ONE FIELD-->
        <div
            v-if="element.currentLang === key"
            class="col-12 dflex"
            :key="index2 + 1000000000 + forceReRenderKey"
            v-for="(key, index2) in Object.keys(element.label.dix)"
        >
            <div class="fit-content">
                <v-form-image-dix-cell
                    :element="element"
                    :image-dix="element.label.imageDix"
                />
            </div>
            <div class="col p-0">
                <textarea
                    rows="300"
                    class="form-text v-form-label form-text-dark ml-1"
                    type="text"
                    v-model="element.label.dix[key]"
                />

                <!--ANSWERS-->
                <div
                    class="dflex mt-1 row"
                    :key="index4 + 98239283"
                    v-for="(item, index4) in element.options"
                >
                    <div class="col col-xxl-4 dflex">
                        <!-- <span class="lighter">{{ $t("slide") }} {{ index4 + 1 }}</span> -->
                        <slide-selector
                            :initial-selected="[item.targetSlide.uuid]"
                            @selected="
                                (uuid, id) => {
                                    item.targetSlide = { uuid, id };
                                }
                            "
                            :slides="slides"
                            :thumbs="thumbs"
                            class=""
                            :display-all-slides="true"
                        />
                    </div>
                    <div class="col-8 col-xxl-8 dflex">
                        <div class="col-10 pl-1 pr-1">
                            <textarea
                                rows="300"
                                placeholder="linktext"
                                class="form-text v-form-label form-text-dark"
                                type="text"
                                v-model="item.text.dix[key]"
                            />
                        </div>

                        <div class="col-2 pl-0 pr-0 text-right">
                            <Button class="icon-button" @click="removeOption(index4)">
                                <icon type="trash-alt" />
                            </Button>
                        </div>
                    </div>
                    <div
                        class="w-100 mt-1 text-right col"
                        v-if="index4 === element.options.length - 1"
                    >
                        <Button class="icon-button" @click="addOption(key)">
                            <icon type="plus" />
                        </Button>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-12">
            <slot />
        </div>
    </div>
</template>

<script>
import Icon from "@/components/Icon";
import Button from "@/components/forms/Button";
import { vFormControls } from "@/enum";
import SlideSelector from "@/components/vForm/SlideSelector";
import vFormImageDixCell from "@/components/vForm/vFormImageDixCell";

export default {
    name: "vFormSLIDE_CONTROL",
    components: {
        Icon,
        Button,
        SlideSelector,
        vFormImageDixCell,
    },
    props: {
        element: { type: Object, required: true },
        stepNo: { type: Number, required: true },
        thumbs: { type: Object, default: null },
        slides: { type: Array, default: null },
        steps: { type: Array, default: null },
    },
    data() {
        return {
            forceReRenderKey: 0,
            editImage: "",
            vFormControls: vFormControls,
        };
    },
    beforeMount() {
        if (!this.element.options) {
            this.addOption("Unknown");
        }
        this.element.formElementType = vFormControls["SLIDE_CONTROL"];
    },
    methods: {
        removeOption(index) {
            this.element.options.splice(index, 1);
        },
        addOption(lang) {
            if (!this.element.options) {
                this.element.options = [];
            }
            this.element.options.push({
                targetSlide: {},
                text: {
                    dix: {
                        [lang]: "",
                    },
                    imageDix: {
                        [lang]: "",
                    },
                },
            });
            this.forceReRenderKey++;
        },
        addTranslation(lang) {
            this.element.label.dix[lang] = {
                isRequired: false,
                emphasized: false,
                showastiles: false,
            };
            this.addOption(lang);

            this.forceReRenderKey++;
        },
    },
};
</script>
